import * as React from 'react'

function LinkedinIcon (props)
{
	const output =
	(
		<svg xmlns="http://www.w3.org/2000/svg" width={ 1024 } height={ 1024 }
			viewBox="0 0 21 21" { ...props }>
			<title>LinkedIn</title>

			<g fill="none" fillRule="evenodd">
				<path fill="inherit" d="M19.479 0H1.583C0.727 0 0 0.677 0 1.511v17.977C0 20.323 0.477 21 1.333 21h17.896C20.086 21 21 20.323 21 19.488V1.511C21 0.677 20.336 0 19.479 0" />
				<path fill="currentColor" d="M19.479 0H1.583C0.727 0 0 0.677 0 1.511v17.977C0 20.323 0.477 21 1.333 21h17.896C20.086 21 21 20.323 21 19.488V1.511C21 0.677 20.336 0 19.479 0zM8 8h2.827v1.441h0.031c0.431-0.777 1.704-1.566 3.278-1.566 3.021 0 3.864 1.604 3.864 4.575V18h-3v-5.003c0-1.33-0.531-2.497-1.773-2.497-1.508 0-2.227 1.021-2.227 2.697V18H8zM3 18h3V8H3zM6.375 4.5c0 1.036-0.839 1.875-1.875 1.875S2.625 5.536 2.625 4.5 3.464 2.625 4.5 2.625 6.375 3.464 6.375 4.5z" />
			</g>
		</svg>
	);

	return output;
}

export default LinkedinIcon
